export default __webpack_public_path__ + "static/moneybus_medium_2-fa8b7b167faae012e3125ad5cdc554dd.webp";